module.exports = __webpack_public_path__ + "static/media/008.64d91e6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/008.jpg
// module id = 305
// module chunks = 0